import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";

import appRoutes from "../../routes/appRoutes";

import MakeAPICall from "../../apiCalls/common";

import {
  exportDataApiRoute,
  getPendingDoctorListApiRoute,
  acceptedDoctorApiRoute,
  rejectedDoctorApiRoute
} from "../../apiRoutes";

import { getFormattedDate, getFormattedTime } from "../../utils/dateTimeHelper";
import { sortData, csUndefined } from "../../utils/commonMethods";

import Button from "../../components/button";
import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";
import CustomModal from "../../components/modal";
import ViewProfilePic from "../../components/viewProfilePic";

import ICNoImg from "../../assets/images/default-picture.png";

const DoctorNewApplicationPage = props => {
  const csvDownRef = useRef(null);
  let history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [currFilters, setCurrFilters] = useState(
    props.location && props.location.state && props.location.state.currPageNo
      ? {
          skip: props.location.state.currPageNo.skip,
          limit: props.location.state.currPageNo.limit
        }
      : {
          skip: 0,
          limit: 10
        }
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [doctorsList, setDoctorsList] = useState([]);
  const [currSelDoct, setCurrSelDoct] = useState(null);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showViewProfilePicModal, setShowViewProfilePicModal] = useState(false);
  const [showSuccModal, setShowSuccModal] = useState(false);
  const [succModalText, setSuccModalText] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  const tableHeaders = [
    {
      key: "docId",
      value: "UIN"
    },
    {
      key: "profilePic",
      value: "Profile Pic"
    },
    {
      key: "fullName",
      value: "Doctor Details"
    },
    { key: "dateOfBirth", value: "DOB" },
    { key: "gender", value: "Gender" },
    {
      key: "action",
      value: "Action"
    }
  ];

  let excelSheetHeader = [
    { label: "UIN", key: "UIN" },
    { label: "Profile Pic", key: "ProfilePic" },
    { label: "First Name", key: "FirstName" },
    { label: "Middle Name", key: "MiddleName" },
    { label: "Last Name", key: "LastName" },
    { label: "Gender", key: "Gender" },
    { label: "Email Address", key: "EmailAddress" },
    { label: "Mobile Number", key: "MobileNumber" },
    { label: "Unit Number", key: "UnitNumber" },
    { label: "Street Number", key: "StreetNumber" },
    { label: "Street Name", key: "StreetName" },
    { label: "Suburb", key: "Suburb" },
    { label: "State", key: "State" },
    { label: "Postcode", key: "Postcode" },
    { label: "Application Date", key: "ApplicationDate" },
    { label: "Application Time", key: "ApplicationTime" },
    {
      label: "Additional Notes on Application",
      key: "AdditionalNotesOnApplication"
    }
  ];

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, doctorsList);
    setDoctorsList(sortedData);
  };

  const showDoctorProfile = id => {
    history.push(appRoutes.doctorNewApplications + "/" + id, {
      currPageNo: currFilters
    });
  };

  // get doctors list
  const getDoctorsList = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getPendingDoctorListApiRoute,
      params: currFilters,
      successCallback: async res => {
        let list = [];

        await res.data.data.doctorData.forEach(column => {
          let d = {};

          d._id = column._id;
          d.docId = column.doctorId;
          d.gender = column.gender;
          d.phoneNumber = column.phoneNumber;
          d.accountState = column.accountState;
          d.visibilityMode = column.visibilityMode;
          d.isBlocked = column.isBlocked;
          d.profilePic =
            column.profilePic === null || column.profilePic === undefined
              ? ICNoImg
              : column.profilePic.original;
          d.dateOfBirth = column.dateOfBirth;
          d.email = column.email;
          d.fullName = column.firstName + " ";
          if (
            column.middleName !== null &&
            column.middleName !== undefined &&
            column.middleName !== ""
          ) {
            d.fullName = d.fullName + column.middleName + " ";
          }

          d.fullName = d.fullName + column.lastName;

          list.push(d);
        });

        setDoctorsList(list);
        setTotalRecords(res.data.data.totalCount);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // export data
  const exportPatData = e => {
    e.preventDefault();

    setIsProcessing(true);
    var formData = new FormData();
    formData.append("who", "doctor");
    formData.append("newapplication", true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: exportDataApiRoute,
      dataObj: formData,
      successCallback: async res => {
        var excelArray = [];
        await res.data.data.forEach(function (column) {
          var e = {};
          e.UIN = column.doctorId;
          e.ProfilePic = column.profilePic.thumb;
          e.FirstName = column.firstName;
          e.MiddleName =
            column.middleName === null ||
            column.middleName === "" ||
            column.middleName === undefined
              ? " "
              : column.middleName;
          e.LastName = column.lastName;
          e.Gender = column.gender;
          e.EmailAddress = column.email;
          e.MobileNumber = column.phoneNumber;
          e.UnitNumber =
            column.address.unitNumber != null ? column.address.unitNumber : "";
          e.StreetNumber = column.address.streetNumber;
          e.StreetName = column.address.streetName;
          e.Suburb = column.address.suburb;
          e.State = column.address.state;
          e.Postcode = column.address.postCode;
          e.ApplicationDate = getFormattedDate(column.createdAt);
          e.ApplicationTime = getFormattedTime(column.createdAt);
          if (column.additionalNotesApplication) {
            e.AdditionalNotesOnApplication = csUndefined(
              column.additionalNotesApplication
            );
          } else {
            e.AdditionalNotesOnApplication = " ";
          }

          excelArray.push(e);
        });

        setExcelSheetData(excelArray);
        setIsProcessing(false);

        // after setting the excel sheet data trigger the csv download component click event
        csvDownRef.current.link.click();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getDoctorsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  // restore the previous page state
  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.currPageNo &&
      props.location.state.currPageNo !== null
    ) {
      setCurrFilters({
        skip: props.location.state.currPageNo.skip,
        limit: props.location.state.currPageNo.limit
      });
    }
  }, []);

  const showDocPicModal = doct => {
    setCurrSelDoct(doct);
    setShowViewProfilePicModal(true);
  };

  const showApproveDocModal = doct => {
    setCurrSelDoct(doct);
    setShowApproveModal(true);
  };

  const showRejectDcoModal = doct => {
    setCurrSelDoct(doct);
    setShowRejectModal(true);
  };

  const approveSelDoctor = () => {
    setShowApproveModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("doctor_id", currSelDoct._id);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: acceptedDoctorApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText(
          "Dr. " + currSelDoct.fullName + " Approved Successfully"
        );
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrModalText(err.message);
        // setShowErrModal(true);
      }
    });
  };

  const rejectSelDoctor = () => {
    setShowRejectModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("doctor_id", currSelDoct._id);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: rejectedDoctorApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText(
          "Dr. " + currSelDoct.fullName + " Rejected Successfully"
        );
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
       // setErrModalText(err.message);
       // setShowErrModal(true);
      }
    });
  };

  return (
    <div className="view-ticket-container logins-page-container">
      <CustomModal
        openModal={showViewProfilePicModal}
        cancelEvent={() => {
          setShowViewProfilePicModal(false);
          setCurrSelDoct(null);
        }}
        title="View Profile Pic"
        modalBodyContent={
          <ViewProfilePic
            profileImg={currSelDoct !== null ? currSelDoct.profilePic : ICNoImg}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showApproveModal}
        cancelEvent={() => {
          setShowApproveModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={approveSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to approve this doctor?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showRejectModal}
        cancelEvent={() => {
          setShowRejectModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={rejectSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to reject this doctor?
          </p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
          setCurrSelDoct(null);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccModal}
        cancelEvent={() => {
          setShowSuccModal(false);
          setSuccModalText("");
          setCurrSelDoct(null);
          getDoctorsList();
        }}
        modalBodyContent={<p className="text-center mb-0">{succModalText}</p>}
      />
      <div className="d-flex flex-row flex-wrap justify-content-between">
        <h3>New Applications</h3>
        <div className="d-flex flex-row align-items-end">
          <Button clickEvent={exportPatData} title="Export to CSV"></Button>
          <CSVLink
            style={{ display: "none" }}
            ref={csvDownRef}
            className="no-text-decoration"
            filename={"New_Application_List.csv"}
            data={excelSheetData}
            headers={excelSheetHeader}
          ></CSVLink>
        </div>
      </div>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {doctorsList.map((doctor, index) => (
            <tr key={index} onClick={() => showDoctorProfile(doctor._id)}>
              <td>{doctor.docId}</td>
              <td
                onClick={e => {
                  e.stopPropagation();
                  showDocPicModal(doctor);
                }}
                className="text-center"
              >
                <img
                  className="rounded-circle user-img"
                  src={doctor.profilePic}
                  alt="user-img"
                />
              </td>
              <td>
                <div className="d-flex flex-column">
                  <p className="mb-0">
                    <b>{doctor.fullName}</b>
                  </p>
                  <a
                    onClick={e => {
                      e.stopPropagation();
                    }}
                    className="high-z-index list-email"
                    href={"mailto:" + doctor.email}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {doctor.email}
                  </a>
                  <p className="mb-0">
                    <ICPhoneDisplay value={doctor.phoneNumber} />
                  </p>
                </div>
              </td>
              <td>{doctor.dateOfBirth}</td>
              <td>{doctor.gender}</td>
              <td>
                <div className="d-flex flex-row align-items-center justify-content-center pt-2">
                  <button
                    className="ic-btn-transparent"
                    onClick={e => {
                      e.stopPropagation();
                      showApproveDocModal(doctor);
                    }}
                  >
                    <i className="fas fa-check"></i> &nbsp; Approve
                  </button>
                  &nbsp;&nbsp;
                  <button
                    className="ic-btn-transparent"
                    onClick={e => {
                      e.stopPropagation();
                      showRejectDcoModal(doctor);
                    }}
                  >
                    <i className="fas fa-times"></i> &nbsp; Reject
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </CustomDataTable>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

export default DoctorNewApplicationPage;
